// constants/paymentConstants.js
export const CREATE_PAYMENT_REQUEST = "CREATE_PAYMENT_REQUEST";
export const CREATE_PAYMENT_SUCCESS = "CREATE_PAYMENT_SUCCESS";
export const CREATE_PAYMENT_FAILURE = "CREATE_PAYMENT_FAILURE";
export const CLEAR_PAYMENT_ERROR = "CLEAR_PAYMENT_ERROR";
